import React, { useState } from 'react';
import { BrainCircuitIcon, TargetIcon, TrendingUpIcon, UsersIcon, MessageSquareIcon, BarChart3Icon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const serviceCategories = [{
  icon: BrainCircuitIcon,
  title: 'Brand & Positioning',
  color: 'from-blue-500 to-cyan-500',
  services: ['Branding image, video & writing guidelines', 'AI-generated product images & descriptions', 'Target market research & ICP development', 'Positioning & UVP drafts', 'Competitor & blue-ocean analysis']
}, {
  icon: TargetIcon,
  title: 'Web & Content',
  color: 'from-purple-500 to-pink-500',
  services: ['Multi-page website copy + SEO schema', 'Blog calendar & content briefs', 'Programmatic SEO page generation', 'Interactive calculators & lead magnets', 'Multilingual localization']
}, {
  icon: TrendingUpIcon,
  title: 'Demand Generation',
  color: 'from-orange-500 to-red-500',
  services: ['Keyword research & ad copy', 'Paid ads optimization', 'Landing page A/B testing', 'Email nurture sequences', 'Webinar pages & follow-ups']
}, {
  icon: UsersIcon,
  title: 'Outbound & Pipeline',
  color: 'from-green-500 to-teal-500',
  services: ['TAM discovery & list building', 'ABM playbooks', 'Cold email/LinkedIn personalization', 'Lead scoring & routing', 'Intent monitoring & alerts']
}, {
  icon: MessageSquareIcon,
  title: 'Sales Assist',
  color: 'from-indigo-500 to-blue-500',
  services: ['SDR copilot for call prep', 'Live call coaching', 'Auto call summaries & CRM logging', 'Proposal generation', 'Contract redlines & suggestions']
}, {
  icon: BarChart3Icon,
  title: 'Analytics & Governance',
  color: 'from-violet-500 to-purple-500',
  services: ['Marketing mix modeling', 'Revenue attribution', 'CAC/LTV dashboards', 'Brand-safety guardrails', 'Prompt library & versioning']
}];
export function Services() {
  const [expandedCard, setExpandedCard] = useState<number | null>(null);
  return <div className="py-24 bg-gray-50" data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-196">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4" data-id="element-197">
            Your Complete AI-Powered
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-198">
              Go-to-Market Engine
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-199">
            From brand strategy to closed deals, every function powered by
            cutting-edge AI
          </p>
        </div>
        {/* Service Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-200">
          {serviceCategories.map((category, index) => {
          const Icon = category.icon;
          const isExpanded = expandedCard === index;
          return <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all cursor-pointer border border-gray-100" onClick={() => setExpandedCard(isExpanded ? null : index)} data-id="element-201">
                {/* Icon */}
                <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${category.color} flex items-center justify-center mb-4`} data-id="element-202">
                  <Icon className="w-7 h-7 text-white" data-id="element-203" />
                </div>
                {/* Title */}
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-204">
                  {category.title}
                </h3>
                {/* Services list */}
                <ul className={`space-y-2 ${isExpanded ? '' : 'line-clamp-3'}`} data-id="element-205">
                  {category.services.map((service, idx) => <li key={idx} className="flex items-start gap-2 text-gray-600 text-sm" data-id="element-206">
                      <ZapIcon className="w-4 h-4 text-blue-500 flex-shrink-0 mt-0.5" data-id="element-207" />
                      <span data-id="element-208">{service}</span>
                    </li>)}
                </ul>
                {/* Expand indicator */}
                <button className="text-blue-600 text-sm font-medium mt-3 hover:text-blue-700" data-id="element-209">
                  {isExpanded ? 'Show less' : 'See all features'}
                </button>
              </div>;
        })}
        </div>
        {/* Bottom CTA */}
        <div className="mt-16 text-center" data-id="element-210">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-3 rounded-full" data-id="element-211">
            <ShieldCheckIcon className="w-5 h-5" data-id="element-212" />
            <span className="font-semibold" data-id="element-213">
              All powered by AI • Zero manual work • Scale instantly
            </span>
          </div>
        </div>
      </div>
    </div>;
}